/* eslint-disable @typescript-eslint/no-explicit-any */
import { Inject, Injectable, InjectionToken, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { encryptionKeys } from '../const/encryptionKey';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';

export const ENCRYPTION_SERVICE_INJECTION_TOKEN: InjectionToken<EncryptionService> =
  new InjectionToken('encryption_sevice_injection_token');
@Injectable()
export class EncryptionService {
  iv = CryptoJS.enc.Base64.parse(encryptionKeys.iv); // giving empty initialization vector
  key = CryptoJS.SHA256(encryptionKeys.key); // hashing the key using SHA256
  encryptedString: any;
  secretKey: any = 'real-estate';

  // eslint-disable-next-line @typescript-eslint/ban-types
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  encryptionPayload(data: any): any {
    data = data.slice();
    this.encryptedString = CryptoJS.AES.encrypt(data, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return this.encryptedString.toString();
  }

  encryptLocalStorage(data: any, key: string): any {
    const encyrpted = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      this.secretKey,
      {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    ).toString();
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, encyrpted);
    }
  }

  encryptHeaders(data: any, type = 'header'): any {
    if (typeof data === 'string') {
      data = data.slice();
      this.encryptedString = CryptoJS.AES.encrypt(data, this.key, {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    } else {
      this.encryptedString = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        this.key,
        {
          iv: this.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      );
    }

    if (type === 'query' && this.encryptedString.toString().includes('+')) {
      this.encryptedString = this.encryptedString
        .toString()
        .split('+')
        .join(environment.storageKey);
    }

    return this.encryptedString.toString();
  }

  decryptionPayload(encryptedData: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, this.key, {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      // Convert the decrypted bytes to a string
      const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);

      return decryptedString;
    } catch (error) {
      return ''; // Return an empty string or handle the error as needed
    }
  }

  decryptLocalStorage<T extends object>(key: string): T {
    const encryptedData: string | null = localStorage.getItem(key);
    if (!encryptedData) return {} as T;

    return JSON.parse(
      CryptoJS.AES.decrypt(encryptedData, this.secretKey, {
        iv: this.iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8)
    );
  }
}
